/**
 * Bootstrap
 */

import {
  // Alert,       // Dismissible alerts
  // Button,      // Toggle button states
  // Carousel,    // Slideshow component
  Collapse, // Accordion-like collapsing elements
  Dropdown, // Dropdown menus
  Modal, // Popup modals
  // Offcanvas,   // Offcanvas sidebars
  // Popover,     // Pop-up content on hover/click (requires @popperjs/core)
  // ScrollSpy,   // Auto-updating navigation based on scroll position
  // Tab,         // Tabs and pills navigation
  // Toast,       // Small pop-up notifications
  // Tooltip      // Tooltips for elements (requires @popperjs/core)
} from "bootstrap";

import bodyLoaded from "./partials/bodyLoaded";
import header from "./partials/header";
import siteSliders from "./partials/sliders";
import readMore from "./partials/readMore";
import newsLoadMore from "./partials/newsLoadMore";
import googleMap from "./partials/googleMap";
import scrollAnimations from "./partials/scrollAnimations";
import modalForm from "./partials/modalForm";

/**
 * MAIN APP JS LOGIC
 */

// CHECK IF DOCUMENT IS READY
if (document.readyState !== "loading") {
  docIsReady();
} else {
  document.addEventListener("DOMContentLoaded", docIsReady);
}

// DOCUMENT READY FUNCTION
function docIsReady() {
  /**
   * Remove body onload layer
   */
  bodyLoaded();

  /**************************************************************************************
        CUSTOM CODE
     **************************************************************************************/

  /**
   * Check if the header is scrolled
   */
  header();

  /**
   * Site sliders
   */
  siteSliders();

  /**
   * Read more sections
   */
  readMore();

  /**
   * Blog Read More
   */
  newsLoadMore();

  /**
   * Site scroll animations
   */
  scrollAnimations();

  modalForm();
} // End Document Ready

/**
 * CUSTOM GOOGLE MAP
 *
 * Must be in global scope and same name as declared in callback on the scripts.php
 */
window.googleMap = googleMap;
